define('notifications/trial-end-notification/trial-end-notification',['require','exports','module','api-access','lib/models/account/check-billing-admin','api-access','mixpanel-helper','jquery','tealium-utils','product-purchase-modal/product-purchase-modal','lib/multivariate-testing/multivariate-testing'],function (require, exports, module) {
    var user = require('api-access').user;
    var checkBillingAdmin = require('lib/models/account/check-billing-admin');
    var commerceApi = require('api-access').commerce;
    var mixpanelHelper = require('mixpanel-helper');
    var $ = require('jquery');
    var tealiumUtils = require('tealium-utils');
    var ProductPurchaseModal = require('product-purchase-modal/product-purchase-modal');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    module.exports = function () {
        var self = this;

        self.show = function () {
            user.updateSettings({marvelTrialExpiredViewed: true, downgradeNotificationViewed: true});
            tealiumUtils.sendTealiumEvent('meetings', 'trial_expiration_modal');
            mixpanelHelper.track('Expired trial modal: Show');

            return $.when(
                user.me(),
                commerceApi.getProducts(),
                multivariateTesting.checkVariation('inProductPurchaseTest')
            ).then(function (userMe, products, variation) {
                var isAccountAdmin = checkBillingAdmin(products[0], userMe[0].key);

                ProductPurchaseModal.show({
                    props: {
                        initialPage: 'g2m-trial-promo',
                        trialDaysLeft: 0,
                        isAccountAdmin: isAccountAdmin,
                        isRedirectCommerce: variation !== 'variation-a',
                        productKey: 'GoToMeeting'
                    },

                    onClose: function () {
                        mixpanelHelper.track('Expired trial modal: Dismiss');
                    }
                });
            });
        };
    };
});

